import React from "react";

import { SearchComponentOfType } from "@utils/search/@types/searchComponent";
import { getInvalidationsForComponent } from "@utils/search/invalidation.utils";

import { useThunkDispatch } from "@redux/dispatcher";
import { configureSearchComponent } from "@redux/modules/value/search/search.actions";
import { useSearchComponentStateSelector } from "@redux/modules/value/search/search.selectors";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { SortComponent } from "./sort.component";

type SortProps = {
    component: SearchComponentOfType<"SORT">;
    configuration: Array<SortConfiguration>;
    className?: string;
};

export type SortItem = {
    label: string;
    value: string;
    isRefined: boolean;
};

export type SortConfiguration = {
    tkLabel: string;
    value: string;
    default?: boolean;
};

const Sort = ({ component, configuration, className }: SortProps) => {
    const { t } = useGranite();

    const dispatch = useThunkDispatch();
    const sortComponentState = useSearchComponentStateSelector(component);

    const defaultSort = configuration.find(sortBy => sortBy.default)?.value;
    const refinedSort = sortComponentState?.sortBy ?? defaultSort;

    const items: Array<SortItem> = configuration.map(sort => ({
        label: t(sort.tkLabel),
        value: sort.value,
        isRefined: sort.value === refinedSort,
    }));
    const refinedItem = items.find(sortBy => sortBy.isRefined);

    const handleOnRefine = (value: string) => {
        dispatch(
            configureSearchComponent(
                {
                    component: component,
                    sortBy: value,
                },
                getInvalidationsForComponent(component),
            ),
        );
    };

    return (
        <SortComponent
            key={refinedItem?.value}
            items={items}
            refinedItem={refinedItem}
            refine={handleOnRefine}
            className={className}
        />
    );
};

export { Sort };
